import { createRouter, createWebHistory } from "vue-router";
import store from "../../packages/rdt/nfc/src/resources/js/store";

const routes = [
    {
        path: "/iniciar_sesion",
        name: "login",
        component: require("../views/auth/login").default,
        props: true,
    },
    {
        path: "/restablecer_contrasena",
        name: "reset",
        component: require("../views/auth/reset").default,
        props: true,
    },
    {
        path: "/recuperar_contrasena",
        name: "recovery",
        component: require("../views/auth/recovery").default,
        props: true,
    },
    {
        path: "/registrarse",
        name: "register",
        component: require("../views/auth/register").default,
        props: true,
    },
    {
        path: "/mi_cuenta",
        name: "profile",
        component: require("../views/layouts/default/components/profile").default,
        props: true,
    },
    {
        path: "/:id?",
        name: "page",
        component: require("../views/page").default,
        props: true,
    },
    {
        path: "/:catchAll(.*)",
        component: () => import("../views/page"),
    },
];

const router = createRouter({
    history: createWebHistory(), //"mode", //createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {
    if(to.fullPath == "/mi_cuenta"){
        store.dispatch("security/isAuth");
        if(store.state.security.authenticate){
            next();
        }else{
            window.location.href = "/";
        }
    }else{
        next();
    }
});

export default router;
